import React from "react";

import initMixpanel from "../../../commons/libs/externals/mixpanel";
import initSentry from "../../../commons/libs/externals/sentry";

interface TrackingContextState {
  sentry?: ReturnType<typeof initSentry>;
  mixpanel?: ReturnType<typeof initMixpanel>;
}

interface Props extends TrackingContextState {
  children: React.ReactNode;
}

const TrackingContext = React.createContext<TrackingContextState | null>({
  sentry: undefined,
  mixpanel: undefined
});

export const TrackingProvider = ({ children, sentry, mixpanel }: Props) => {
  return <TrackingContext value={{ sentry, mixpanel }}>{children}</TrackingContext>;
};

export const useTrackingContext = (): TrackingContextState => {
  const context = React.useContext(TrackingContext);

  if (context === null) {
    throw new Error("useTrackingContext must be used within a TrackingProvider");
  }

  return context;
};
